import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';
import { navigate } from 'react-big-calendar/lib/utils/constants';
import moment from 'moment/moment';
import LocaleUtils from 'react-day-picker/moment';
import DayPickerInput from 'react-day-picker/DayPickerInput';

import classes from './Toolbar.scss';

class Toolbar extends React.Component {
  static propTypes = {
    view: PropTypes.string.isRequired,
    views: PropTypes.arrayOf(PropTypes.string).isRequired,
    label: PropTypes.node.isRequired,
    messages: PropTypes.object,
    onNavigate: PropTypes.func.isRequired,
    onViewChange: PropTypes.func.isRequired,
  };

  render() {
    let { messages, label } = this.props;

    const dayPickerProps = {
      todayButton: 'Zum aktuellen Monat',
      enableOutsideDays: true,
      modifiers: {
        monday: { daysOfWeek: [1] },
      },
      localeUtils: LocaleUtils,
      locale: 'de',
      format: 'DD.MM.YYYY',
    };

    const date = moment(this.props.date).format(dayPickerProps.format);

    return (
      <div className="rbc-toolbar">
        <span className="rbc-btn-group">
          <button
            type="button"
            onClick={this.navigate.bind(null, navigate.TODAY)}
          >
            {messages.today}
          </button>
          <button
            type="button"
            onClick={this.navigate.bind(null, navigate.PREVIOUS)}
          >
            {messages.previous}
          </button>
          <button
            type="button"
            onClick={this.navigate.bind(null, navigate.NEXT)}
          >
            {messages.next}
          </button>
        </span>

        <span className="rbc-toolbar-label form">
          {label}
          <br />
          <DayPickerInput
            value={date}
            onDayChange={this.handleDayChange}
            dayPickerProps={dayPickerProps}
            format={this.props.dateFormat}
            placeholder={`bspw. ${moment()
              .locale('de')
              .format(this.props.dateFormat)}`}
          />
        </span>

        <span className="rbc-btn-group">{this.viewNamesGroup(messages)}</span>
      </div>
    );
  }

  navigate = action => {
    this.props.onNavigate(action);
  };

  view = view => {
    this.props.onViewChange(view);
  };

  handleDayChange = date => {
    this.props.onNavigate(navigate.DATE, date.toDate());
  };

  viewNamesGroup(messages) {
    let viewNames = this.props.views;
    const view = this.props.view;

    if (viewNames.length > 1) {
      return viewNames.map(name => (
        <button
          type="button"
          key={name}
          className={cn({ 'rbc-active': view === name })}
          onClick={this.view.bind(null, name)}
        >
          {messages[name]}
        </button>
      ));
    }
  }
}

export default Toolbar;



// WEBPACK FOOTER //
// ./src/components/ActivityTable/Toolbar.js